import { render, staticRenderFns } from "./ChartResumen.vue?vue&type=template&id=80bc9628"
import script from "./ChartResumen.vue?vue&type=script&lang=js"
export * from "./ChartResumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports